import React, {Component} from 'react';

export default class EmptyPage extends Component {
  render() {
    return <div>{'Page you are looking for does not exist'}</div>;
  }
}
